<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
        <g id="Group_3801" data-name="Group 3801" transform="translate(-1235 -277.5)">
            <circle id="Ellipse_167" data-name="Ellipse 167" cx="22.5" cy="22.5" r="22.5" transform="translate(1235 277.5)" fill="#4d2940" opacity="0.099"/>
            <g id="Group_3409" data-name="Group 3409" transform="translate(-3368.727 383.396)">
                <path id="Path_719" data-name="Path 719" d="M4623.4-77.4a.851.851,0,0,1-.606-.247l-3.79-3.9a.878.878,0,0,1-.028-1.259.875.875,0,0,1,1.258-.028l2.777,1.981a.364.364,0,0,0,.536-.058l6.58-8.129a.881.881,0,0,1,1.244-.173.882.882,0,0,1,.172,1.244l-7.432,10.211a.9.9,0,0,1-.638.345.124.124,0,0,1-.074.016Z" transform="translate(-0.001 0)" fill="#254150"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "previously-completed"
}
</script>

<style scoped>

</style>
